/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_Allocation_PreviewInputs */

const vi_customer_debt_payment_allocation_preview = /** @type {(inputs: Customer_Debt_Payment_Allocation_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bổ vào đơn còn nợ`)
};

/**

* @param {Customer_Debt_Payment_Allocation_PreviewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_allocation_preview = /** @type {((inputs?: Customer_Debt_Payment_Allocation_PreviewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_Allocation_PreviewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_allocation_preview(inputs)
});